import { Modal, Select, Spin } from "antd";
import React, { Component } from "react";
import { save } from "../../../../utils/db_functions";
import { getProposalManagementStatusColor } from "../suport-files/proposal-management-status";

const PROPOSAL_MANAGEMENT_STATUS_OPTIONS = [
    { label: "Elaboração", value: "Elaboração" },
    { label: "Liberada", value: "Liberada" },
    { label: "Negociação", value: "Negociação" },
    { label: "Cancelada", value: "Cancelada" },
    { label: "Substituída", value: "Substituida" },
    { label: "Aprovada", value: "Aprovada" },
]

export default class ProposalStatusClass extends Component {

    constructor(props) {
        super(props)
        this.state = {
            proposal: this.props.proposal,
            loading: false,
            statusModal: false,
            status: this.props.proposal.proposal_management_status,
            statusColor: null,
        }
    }

    componentDidMount() {
        if (this.props.orderVersionProposal) {
            this.setStatusOrderColor(this.props.proposal, this.props.orderVersionProposal)
        } else this.setStatusColor()
    }

    setStatusColor() {
        const status = this.state.status || this.state.proposal.proposal_management_status
        const statusColor = getProposalManagementStatusColor(
            status,
            this.state.proposal.orderGenerated
        )

        this.setState({ statusColor, status: status || null })
    }

    async updateStatus(proposalId, status) {
        this.setState({ loading: true })

        try {
            let proposalToUpdate = { proposal_management_status: status }
            if (status !== 'Aprovada' && status !== 'PedidoGerado' && status !== 'Liberada') {
                proposalToUpdate['orderGenerated'] = false
            }

            await save('Proposal', proposalToUpdate, proposalId)

            this.setState({
                status,
                proposal: {
                    ...this.state.proposal,
                    proposal_management_status: status,
                    ...(proposalToUpdate.orderGenerated === false ? { orderGenerated: false } : {}),
                },
                statusModal: false,
            }, () => this.setStatusColor())
        } finally {
            this.setState({ loading: false })
        }
    }

    setStatusOrderColor(proposal, orderVersionProposal) {
        const orderVersion = parseInt(orderVersionProposal.proposal_code.slice(-2), 10)
        const proposalVersion = parseInt(proposal.proposal_code.slice(-2), 10)
        let color = 'green'

        if (proposalVersion < orderVersion) color = 'lightgreen'
        else if (proposalVersion > orderVersion) color = 'darkgreen'

        this.setState({ statusColor: color })
    }

    render() {
        const statusStillInOptions = PROPOSAL_MANAGEMENT_STATUS_OPTIONS.some(
            (option) => option.value === this.state.status
        )

        return (
            <div>
                <div
                    onClick={() => this.setState({ statusModal: true })}
                    style={{
                        backgroundColor: this.state.statusColor,
                        width: '20px', height: '20px',
                        margin: 'auto', borderRadius: '50%',
                        cursor: 'pointer',
                    }}
                />
                <Modal
                    title={`Atualizar status da proposta ${this.state.proposal.proposal_code}`}
                    visible={this.state.statusModal}
                    onOk={() => this.updateStatus(this.state.proposal.objectId, this.state.status)}
                    onCancel={() => this.setState({ statusModal: false, loading: false })}
                >
                    <Spin spinning={this.state.loading}>
                        <Select
                            placeholder='Status'
                            onChange={e => {
                                this.setState({
                                    status: e,
                                    proposal: { ...this.state.proposal, proposal_management_status: e }
                                })
                            }}
                            value={this.state.status}
                            style={{ width: '100%' }}
                        >
                            <Select.Option value={null}>Selecione...</Select.Option>
                            {!statusStillInOptions && this.state.status && (
                                <Select.Option value={this.state.status}>{this.state.status}</Select.Option>
                            )}
                            {PROPOSAL_MANAGEMENT_STATUS_OPTIONS.map((option) => (
                                <Select.Option key={option.value} value={option.value}>
                                    {option.label}
                                </Select.Option>
                            ))}
                        </Select>
                    </Spin>
                </Modal>
            </div>
        );
    }

}
